import * as yup from 'yup';

export const password = yup
    .string()
    .min(8, 'Must be a minimum of 8 characters')
    .matches(/[a-z]/, 'Must include a lower case character')
    .matches(/[A-Z]/, 'Must include an uppercase character')
    .matches(/\d/, 'Must include a number character')
    .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Must include a special character');

export const repeatPassword = yup.string().oneOf([yup.ref('password')], 'Passwords must match');
